import { render, staticRenderFns } from "./InnerBlock.vue?vue&type=template&id=159756be&"
import script from "./InnerBlock.vue?vue&type=script&lang=js&"
export * from "./InnerBlock.vue?vue&type=script&lang=js&"
import style0 from "./InnerBlock.vue?vue&type=style&index=0&id=159756be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports